module.exports = __webpack_public_path__ + "static/2019-fineArt4-b55db7d18e4b6d7bf2567fba9c3a826c.jpg";